import Vue from "vue";
import Vuetify from "vuetify/lib";

import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);
const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#2026B2",
        secondary: "#00008b",
        accent: "#EB4E62",
        error: "#FF1744",
        warning: "#ffd740",
        info: "#60CFFD",
        success: "#4caf50",
        light: "#5e92f3",
        dark: "#003c8f",
        twhite: "#ffffff"
      }
    }
  },
  icons: {
    iconfont: "mdi" // default - only for display purposes
  }
});
export default vuetify;
